import { render, staticRenderFns } from "./RipaSubmission.vue?vue&type=template&id=2a8846f6"
import script from "./RipaSubmission.vue?vue&type=script&lang=js"
export * from "./RipaSubmission.vue?vue&type=script&lang=js"
import style0 from "./RipaSubmission.vue?vue&type=style&index=0&id=2a8846f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports